/**
 * @module components\ghTree
 */

import Component from "vue-class-component";
import { Prop, Inject, Model, Mixins } from "vue-property-decorator";
import { TreeNode, ElTree } from "element-ui/types/tree";
import { Watch } from "vue-property-decorator";
import TreeProps from "./treeProps";
import Tree from "./tree";

@Component
export default class GhTree extends Mixins(Tree) {
  /**
   * 当前选择的节点
   */
  @Model("input")
  current!: any;

  /**
   * 当前选择节点的key值
   */
  private currentKey: string | number = "-1";

  /**
   * 监听器
   */
  private get listeners() {
    return Object.assign({}, this.$listeners);
  }

  /**
   * 树节点改变时
   * @param data 树节点对应的数据
   * @param node 树节点对应的Node
   */
  private currentChange(data, node: TreeNode<any, any>) {
    if (node && node.key) {
      this.currentKey = node.key;
      this.$emit("input", node);
      this.$emit("update:currentNodeKey", node.key);
    }
  }

  /**
   * 设置当前选择的节点
   */
  @Watch("data")
  private sync() {
    let tree = this.$refs.tree as ElTree<any,any>;
    this.$nextTick(() => {
      tree.setCurrentKey(this.currentKey);
    });
  }
  /**
   * 挂在时，设置当前选中节点与展开的节点
   */
  mounted() {
    if (this.currentNodeKey) {
      this.currentKey = this.currentNodeKey;
    }
    if (this.defaultExpandedKeys) {
      this.expandedKeys = this.defaultExpandedKeys;
    }
  }
}
